// eslint-disable-next-line filename-rules/match
import type { NextPage } from 'next';

import { BLOG_PAGE_SIZE } from '@webapp/common/lib/const';
import { ColorScheme } from '@webapp/common/lib/ui';
import { BlogCards } from '@webapp/landing/src/components/blog-cards';
import type { IBlogCards } from '@webapp/landing/src/components/blog-cards';
import { Head } from '@webapp/landing/src/components/head';
import { Layout } from '@webapp/landing/src/components/layout';
import type { CmsPage } from '@webapp/landing/src/resources/api';
import { fetchBlogPages, fetchPage } from '@webapp/landing/src/resources/api';

const BlogIndex: NextPage<{
    cards: IBlogCards;
    page: number;
    totalPages: number;
    content: CmsPage;
}> = ({ cards, page, totalPages, content }) => {
    return (
        <>
            <Head
                description={content.descr}
                keywords={content.keywords}
                title={`${content.browserTitle} - страница ${page}`}
                url='ru/blog'
            />
            <Layout contentPage={true} mode={ColorScheme.DARK} withMenu={true}>
                <BlogCards cards={cards} page={page} totalPages={totalPages} />
            </Layout>
        </>
    );
};

BlogIndex.getInitialProps = async ({ query: { page } }) => {
    const pageParsed = parseInt(page as string, 10);
    const pageForPagination = isFinite(pageParsed) ? pageParsed : 1;
    const { rows, total } = await fetchBlogPages(pageForPagination - 1, BLOG_PAGE_SIZE /*, ua*/);
    const data = await fetchPage('blog');

    const cards = rows.map(({ browserTitle, descr, imageHeight, imagePath, imageWidth, rewrite }) => ({
        title: browserTitle as string,
        description: descr as string,
        link: `/ru/blog/${rewrite}`,
        teaserImg: imagePath
            ? {
                  url: imagePath as string,
                  width: imageWidth as number,
                  height: imageHeight as number
              }
            : null
    }));

    return {
        content: data.blogData || ({} as CmsPage),
        cards,
        page: pageForPagination,
        totalPages: total
    };
};

// eslint-disable-next-line import/no-default-export
export { BlogIndex as default };
